import deepmerge from 'deepmerge';
import { freeze } from 'immer';
import Cookies from 'js-cookie';

import * as APP_INSTANCE from '@constants/appInstance';
import * as COOKIES from '@constants/cookies';
import { isLocal, isProduction } from '@helpers/env';

import { baseConfig } from './baseConfig';
import { vatitConfig, vsuiteConfig } from './instanceConfig';
import { localConfig } from './localConfig';

const appInstanceOverwrite = !isProduction() ? Cookies.get(COOKIES.INSTANCE) : '';
const appInstance = appInstanceOverwrite || process.env.INSTANCE || APP_INSTANCE.VSUITE;
const base = deepmerge(baseConfig, appInstance === APP_INSTANCE.VATIT ? vatitConfig : vsuiteConfig);

/**
 * App configuration
 */
export const appConfig = freeze(
  deepmerge({ ...base, appInstance }, isLocal() ? localConfig : {}),
  true
);
